<template>
    <div>
        <!-- <crud-table :actions="actions" show-search search-placeholder="ابحث باسم الدورة" server-pagination :page-count="exams.meta.last_page" :current-page="exams.meta.current_page" :total="exams.meta.total" :per-page="exams.meta.per_page" title="الدورات" :items="examsItemsComputed" :headers="headers" @edit="openEditDialog" @delete="openDeleteDialog" @load="loadMore" @create="createDialog =  true" @search="search" @hide="openHideDialog" @unhide="openUnhideDialog" @feature="openFeatureDialog" @unfeature="openUnfeatureDialog" @reset="reset" /> -->
        <v-card class="soft-shadow py-2 px-3 mb-4 mb-lg-6">
            <v-card-text >
                <div class="d-flex justify-space-between">
                    <div>
                        <div class="mb-3 d-flex align-center">
                            <h2 class="font-weight-medium strong-text--text" style="line-height: 1">{{examData.name}}</h2>
                            <div v-if="enableGenericExams" class="font-weight-medium medium-text text--text ms-2">(#{{examData.exam_code}})</div>
                        </div>
                        <div>
                            <div class="teachers d-flex">
                                <div>
                                    <v-chip v-if="examData.category" label small class="px-2 me-2">
                                        <v-icon size="16" class="me-2">mdi-tag-outline</v-icon>
                                        <span>{{examData.category.name}}</span>
                                    </v-chip>
                                    <v-chip v-if="examData.status === 'not-started'" label small color="blue-grey" dark class="px-2 me-2">
                                        <v-icon size="16" class="me-2">mdi-lock-clock</v-icon>
                                        <span>لم يبدأ</span>
                                    </v-chip>
                                    <v-chip v-else-if="examData.status === 'ended'" label small color="red" dark class="px-2 me-2">
                                        <v-icon size="16" class="me-2">mdi-lock-clock</v-icon>
                                        <span>منتهي</span>
                                    </v-chip>
                                    <v-chip v-else-if="examData.status === 'active'" label small color="green" dark class="px-2 me-2">
                                        <v-icon size="16" class="me-2">mdi-check-circle</v-icon>
                                        <span>نشط</span>
                                    </v-chip>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="header-actions">
                        <v-btn outlined text @click="editDialog = true">
                            <v-icon left>mdi-pencil</v-icon>
                            <span>تعديل</span>
                        </v-btn>
                    </div>
                </div>
                <div>
                    <v-subheader class="details-text strong-text--text mt-4 px-0">تفاصيل الامتحان</v-subheader>
                    <v-list two-line class="pa-0 transparent" style="max-width: 1000px">
                        <v-row class="ma-0">
                            <v-col v-if="enableGenericExams" cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon>mdi-form-textbox-password</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>كود الامتحان</v-list-item-subtitle>
                                        <v-list-item-title>{{examData.exam_code}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon>mdi-timer-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>مدة الامتحان</v-list-item-subtitle>
                                        <v-list-item-title>
                                            <span v-if="examData.duration">{{examData.duration}} دقيقة</span>
                                            <span v-else>____</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>نسبة النجاح</v-list-item-subtitle>
                                        <v-list-item-title>{{examData.pass_percentage}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <!-- <v-icon>mdi-clipboard-arrow-up-outline</v-icon> -->
                                        <v-icon>mdi-license</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>درجة السؤال الافتراضية</v-list-item-subtitle>
                                        <v-list-item-title>{{examData.question_mark}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon color="blue-grey">mdi-file-percent-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>عرض النتيجة</v-list-item-subtitle>
                                        <v-list-item-title>{{examData.show_result ? 'نعم' : 'لا'}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon color="blue-grey">mdi-shuffle-variant</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>ترتيب اﻷسئلة عشوائياً</v-list-item-subtitle>
                                        <v-list-item-title>{{examData.shuffled_questions ? 'نعم' : 'لا'}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon color="indigo">mdi-clipboard-text-clock</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>يبدأ في</v-list-item-subtitle>
                                        <v-list-item-title class="medium-text ltr-dir text-right">{{examData.starts_at ? dateTimeFormat(examData.starts_at) : '____'}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" lg="3" class="pa-0">
                                <v-list-item class="ps-lg-0">
                                    <v-list-item-icon>
                                        <v-icon color="error">mdi-clock-end</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>ينتهي في</v-list-item-subtitle>
                                        <v-list-item-title class="medium-text ltr-dir text-right">{{examData.ends_at ? dateTimeFormat(examData.ends_at) : '____'}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-list>
                </div>
                <!-- <v-divider class="my-3"></v-divider> -->
            </v-card-text>
        </v-card>

        <v-card class="soft-shadow px-3 mb-4 mb-lg-6">
            <v-card-title class="d-flex justify-space-between align-center mb-1">
                <div>أسئلة الامتحان</div>
                <div class="actions">
                    <!-- <transition name="fade-transition" mode="out-in"> -->
                        <div v-if="!sortQuestions" class="d-flex align-center" key="1">
                            <v-btn color="primary" @click="addQuestionsDialog = true">
                                <v-icon size="20" left>mdi-file-question-outline</v-icon>
                                إضافة من بنك اﻷسئلة
                            </v-btn>

                            <v-btn color="purple" @click="enableQuestionsSorting" dark class="ms-2" v-if="!examData.shuffled_questions">
                                <v-icon size="20" left>mdi-sort</v-icon>
                                تغيير الترتيب
                            </v-btn>
                        </div>
                        <div v-else class="d-flex align-center" key="2">

                            <v-btn color="muted" @click="cancelQuestionsSorting" depressed outlined :disabled="savingQuestionsOrder">
                                <v-icon size="20" left>mdi-close</v-icon>
                                إلغاء التغييرات
                            </v-btn>
                            <v-btn color="success" @click="saveQuestionsOrder" class="ms-2" :loading="savingQuestionsOrder" depressed>
                                <v-icon size="20" left>mdi-check-circle-outline</v-icon>
                                حفظ الترتيب الجديد
                            </v-btn>

                        </div>
                    <!-- </transition> -->
                </div>
            </v-card-title>
            <v-card-subtitle>
                <v-chip small label>
                    <v-icon size="16" class="me-2">mdi-file-question-outline</v-icon>
                    عدد اﻷسئلة: <b class="ms-1">{{questionsData.length}}</b>
                </v-chip>
            </v-card-subtitle>
            <v-card-text class="pb-2">

                <v-list ref="questionsList" v-if="questionsData && questionsData.length" :two-line="!sortQuestions" class="pa-0 mb-3">
                    <v-list-item v-for="question in questionsData" :key="question.id" v-ripple="phoneOnly" @click="questionDetailsDialog = true; questionDetails = question">
                        <v-list-item-icon>
                            <v-icon color="strong-text">{{question.type === 'essay' ? 'mdi-text-box-outline' : 'mdi-file-question-outline'}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{question.name}}

                                <v-chip v-if="sortQuestions" small label class="grey lighten-3 ms-3 px-2" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop style="height: 20px">
                                    معرف #{{question.id}}
                                </v-chip>
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="!sortQuestions">
                                <v-chip small label class="grey lighten-3 me-1 px-2" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop style="height: 20px">
                                    #{{question.id}}
                                </v-chip>
                                <v-chip small label :dark="!!question.custom_mark" :color="question.custom_mark ? 'deep-purple' : 'grey lighten-3'" class="px-2 me-1" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop style="height: 20px">
                                    <v-icon size="16" class="me-1">mdi-license</v-icon>
                                    <span><span class="small-text">الدرجة:</span> <b>{{question.custom_mark ? question.custom_mark : examData.question_mark}}</b></span>
                                </v-chip>
                                <v-chip v-if="question.answers.find(answer=>!!answer.correct)" color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                    <span class="small-text me-1">الإجابة: </span>
                                    <v-icon v-if="question.answers.find(answer=>!!answer.correct).image_url && !question.answers.find(answer=>!!answer.correct).text" small>mdi-image</v-icon>
                                    <span v-else>{{textMax(question.answers.find(answer=>!!answer.correct).text, 40)}}</span>
                                </v-chip>
                                <v-chip v-if="question.success_rate !== null" small label outlined :color="question.success_rate < 20 ? 'error darken-1' : (question.success_rate < 50 ? 'orange darken-3' : 'success darken-1' )" class="px-2 me-1">
                                    <v-icon size="14" class="me-1">mdi-radiobox-marked</v-icon>
                                    <span>نسبة الحل <b>{{question.success_rate || question.success_rate === 0 ? question.success_rate : '---'}} %</b></span>
                                </v-chip>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon v-if="!sortQuestions">
                            <v-btn icon color="primary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="questionDetailsDialog = true; questionDetails = question;">
                                <v-icon size="22">mdi-file-eye-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="deep-purple" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="openEditQuestionDialog(question)">
                                <v-icon size="22">mdi-license</v-icon>
                            </v-btn>
                            <v-btn icon color="error" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="removeQuestionDialog = true; removeQuestion = question;">
                                <v-icon size="22">mdi-close</v-icon>
                            </v-btn>
                        </v-list-item-icon>
                        <v-list-item-icon v-else>
                            <v-icon color="muted" size="20">mdi-cursor-move</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>

                <div v-else class="py-2">
                    <v-alert text type="info" color="blue-grey darken-1">
                        لا يوجد أسئلة مرتبطة بهذا الامتحان، ابدأ بإضافة اﻷسئلة اﻵن
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-if="examData.has_manual_correction" class="soft-shadow pa-3 pt-0 mb-4 mb-lg-6">
            <v-card-title>
                <v-icon color="strong-text" class="me-2">mdi-clipboard-check-outline</v-icon>
                التصحيح اليدوي
            </v-card-title>
            <v-card-text>
                <v-alert v-if="examData.waiting_manual_correction_count" type="info" text dense small color="deep-orange">
                    <span class="medium-text strong-text--text">
                        لم يتم تصحيح {{examData.waiting_manual_correction_count}} إجابة تتطلب التصحيح اليدوي!
                    </span>
                </v-alert>
                <v-alert v-else type="success" text dense small color="success">
                    <span class="medium-text strong-text--text">
                        تم تصحيح جميع الإجابات التي تتطلب تصحيحا يدوياً
                    </span>
                </v-alert>

                <div class="d-flex">
                    <v-btn as="v-btn" :dark="!!examData.waiting_manual_correction_count" :disabled="!examData.waiting_manual_correction_count" :to="{name: 'attempts-correction', params: {id: id}}" depressed color="deep-orange" class="px-3">
                        <v-icon size="20" left>mdi-clipboard-text-multiple-outline</v-icon>
                        <b>تصحيح الإجابات ({{examData.waiting_manual_correction_count}})</b>
                    </v-btn>

                    <v-btn as="v-btn" :disabled="!!examData.waiting_manual_correction_count || !examData.never_corrected_sessions_count" depressed color="success" class="px-3 ms-3" @click="autoCorrectSessionsDialog = true;">
                        <v-icon size="20" left>mdi-progress-check</v-icon>
                        <b>التجميع والتصحيح الآلي للجلسات</b> <span v-if="examData.never_corrected_sessions_count" class="ms-1">({{examData.never_corrected_sessions_count}})</span>
                    </v-btn>
                </div>

                <!-- <inertia-link as="v-btn" dark :href="`/exams/sessions/exams/${id}`" depressed color="primary" class="px-3 ms-2">
                    <v-icon size="20" left>mdi-clipboard-text-multiple-outline</v-icon>
                    <b>إجابات تم تصحيحها</b>
                </inertia-link> -->
            </v-card-text>
        </v-card>

        <v-card class="soft-shadow pa-3 pt-0 mb-4 mb-lg-6">
            <v-card-title>
                <v-icon color="strong-text" class="me-2">mdi-license</v-icon>
                الجلسات ونتائج الطلاب
            </v-card-title>
            <v-card-subtitle>تفاصيل جلسات الامتحان ونتائج التصحيح اﻹلكتروني لكل جلسة</v-card-subtitle>

            <v-card-text>
                <v-btn v-if="sessions_count" :to="{name: 'exam-sessions', params: {id}}" depressed color="primary" class="px-6">
                    <v-icon size="20" left>mdi-clipboard-text-multiple-outline</v-icon>
                    <span>عرض نتائج الطلاب ({{sessions_count}})</span>

                </v-btn>
                <v-alert v-else text dense type="info" color="blue-grey">
                    <span class="medium-text strong-text--text">لم يخض أي طالب الامتحان حتى اﻵن</span>
                </v-alert>
            </v-card-text>
        </v-card>


        <action-dialog v-model="editQuestionDialog" action="put" :url="`/exams/${examData.id}/questions/${editedQuestion ? editedQuestion.id : ''}`" success-msg="تم حفظ التغييرات بنجاح" title="تعديل درجة السؤال" subtitle="يمكنك من هنا تخصيص درجة للسؤال تختلف عن الافتراضية لأسئلة الامتحان" button-text="حفظ" :data="{custom_mark: editedQuestion.custom_mark}" @reset="resetEditQuestionDialog" @sync="syncQuestion">
            <v-text-field v-model="editedQuestion.custom_mark" type="number" min="0" autofocus label="درجة السؤال"></v-text-field>
        </action-dialog>

        <action-dialog v-model="removeQuestionDialog" action="delete" :url="`/exams/${examData.id}/questions/${removeQuestion ? removeQuestion.id : ''}`" title="إزالة السؤال" button-text="تأكيد الحذف" button-color="error" @sync="removeQuestionItem(removeQuestion.id)">
            <div v-if="removeQuestion">
                <p class="strong-text--text mb-0">
                    هل أنت متأكد من إزالة السؤال <b class="strong-text--text">"{{removeQuestion.name}}"</b> من أسئلة الامتحان؟
                </p>
            </div>
        </action-dialog>


        <action-dialog v-model="autoCorrectSessionsDialog" action="post" :url="`/exams/${examData.id}/autocorrection`" title="التصحيح الآلي للجلسات" button-text="تأكيد" button-color="success" @sync="sync">
            <p class="text--text mb-0">
                سيتم التصحيح الآلي واعتماد درجات {{unitFormat(examData.never_corrected_sessions_count, 'جلسة', 'جلستين', 'جلسات')}}
            </p>
        </action-dialog>

        <edit-dialog v-model="editDialog" :data="examData" :categories="categoriesSelectItems" no-reset @sync="sync" />
        <add-questions-dialog v-model="addQuestionsDialog" :exam="examData" :exam-questions="questionsData" @sync="syncQuestions" />
        <question-details v-model="questionDetailsDialog" :question-details="questionDetails" />
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'
import StatCard from '@/components/default/stat-card'
import EditDialog from '@/components/custom/edit-dialog'
import AddQuestionsDialog from './add-questions-dialog'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import QuestionDetails from '@/components/custom/questions-details'
import Sortable from 'sortablejs';

export default {
    components: {
        CrudTable,
        StatCard,
        EditDialog,
        AddQuestionsDialog,
        QuestionDetails
    },
    props: {
        exam: {},
        questions: {},
        categories_select_items: {},
        sessions_count: {},
    },
    data() {
        return {
            examData: null,
            addQuestionsDialog: false,

            editDialog: false,
            questionsData: null,

            removeQuestionDialog: false,
            removeQuestion: null,

            editQuestionDialog: false,
            editedQuestion: {
                id: null,
                custom_mark: '',
            },

            questionDetailsDialog: false,
            questionDetails: null,

            questionsOldOrder: null,
            sortableInstance: null,
            sortQuestions: false,
            savingQuestionsOrder: false,
            
            autoCorrectSessionsDialog: false,
        }
    },
    computed: {
        id(){
            return this.examData.id;
        },
        page_url(){
            return '/exams/' + this.examData.id;
        },
        categoriesSelectItems(){
            if (this.categories_select_items){
                return this.categories_select_items.map(category=>{
                    return {text: category.name, value: category.id};
                })
            }else{
                return [];
            }
        },
        enableGenericExams(){
            return !!this.appData.enable_gen_exm;
        },
        ...GlobalComputed,
    },
    watch: {
        sortQuestions(sort){
            if (this.sortableInstance){
                this.sortableInstance.option('disabled', !sort);
            }
        }
    },
    methods: {
        ...GlobalMethods,
        openEditQuestionDialog(question){
            this.editQuestionDialog = true;
            Object.assign(this.editedQuestion, question);
        },
        resetEditQuestionDialog(question){
            Object.assign(this.editedQuestion, {id: null, custom_mark: ''});
        },
        sync(data){
            Object.assign(this.examData, data);
        },
        syncQuestions(questions){
            this.questionsData = questions;
        },
        removeQuestionItem(id){
            this.questionsData = this.questionsData.filter(item=>{
                return item.id !== id;
            });
        },
        syncQuestion(question){
            this.questionsData = this.questionsData.map(item=>{
                if (item.id === question.id){
                    return Object.assign(item, question);
                }
                return item;
            })
        },
        enableQuestionsSorting(){
            const oldQuestions = [...this.questionsData];
            this.questionsOldOrder = oldQuestions;
            this.sortQuestions = true;
        },
        cancelQuestionsSorting(){
            this.questionsData = this.questionsOldOrder;
            this.sortQuestions = false;
        },
        updateQuestionsOrder(event) {
            // apply new order (localy)
            const movedItem = this.questionsData.splice(event.oldIndex, 1)[0];
            this.questionsData.splice(event.newIndex, 0, movedItem);
        },
        saveQuestionsOrder(){
            // save new order (server)
            const questions_order = this.questionsData.map((item, index)=>{
                return {question_id: item.id, order: index+1};
            });

            if (!this.savingQuestionsOrder){
                this.savingQuestionsOrder = true;
                this.$store.dispatch('fastPostAction', {url: `/exams/${this.id}/questions/order`, data: {order: questions_order}}).then(response=>{
                    // sort done
                    this.showMsg('تم حفظ ترتيب اﻷسئلة بنجاح', 'success');
                    this.savingQuestionsOrder = false;
                    this.sortQuestions = false;
                    this.syncQuestions(response.data.questions);

                }).catch(e=>{
                    this.showMsg('حدثت مشكلة أثناء ترتيب اﻷسئلة', 'error');
                    // revert updates
                    this.cancelQuestionsSorting();
                    this.savingQuestionsOrder = false;
                });
            }
        },
        textMax(text, length){
            return text ? (text.length > length ? text.slice(0, length) + ' ...' : text) : '';
        },
    },
    created(){
        this.examData = this.exam.data;
        this.questionsData = this.questions.data;
    },
    mounted(){
        const self = this;
        const options = {
            animation: 150,
            onUpdate: function (event) {
                self.updateQuestionsOrder(event);
            },
            disabled: !this.sortQuestions,
        };

        window.setTimeout(()=>{
            // set this.sortableInstance to Sortable Object so we can update it's options later
            this.sortableInstance = Sortable.create(self.$refs.questionsList.$el, options)
        }, 500);
    }
}

</script>
